import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DocOfertaWizardComponent } from './doc-oferta-wizard/doc-oferta-wizard.component';
import { DocOfertasDetalleComponent } from './doc-ofertas-detalle/doc-ofertas-detalle.component';
import { DocOfertasActivasComponent } from './doc-ofertas-activas/doc-ofertas-activas.component';
import { DocOfertasRevisionComponent } from './doc-ofertas-revision/doc-ofertas-revision.component';
import { DocOfertasHistorialComponent } from './doc-ofertas-historial/doc-ofertas-historial.component';
import { BreadcrumbModule } from 'src/app/_layout/breadcrumb/breadcrumb.module';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/_layout/blockui/block-template.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ArchwizardModule } from 'angular-archwizard';
import { CardModule } from '../partials/general/card/card.module';
import { MatchHeightModule } from '../partials/general/match-height/match-height.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DocOfertaPostulantesComponent } from './doc-oferta-postulantes/doc-oferta-postulantes.component';
import { DocPostulanteDetallesComponent } from './doc-postulante-detalles/doc-postulante-detalles.component';

@NgModule({
  declarations: [
    DocOfertaWizardComponent,
    DocOfertasDetalleComponent,
    DocOfertasActivasComponent,
    DocOfertasRevisionComponent,
    DocOfertasHistorialComponent,
    DocOfertaPostulantesComponent,
    DocPostulanteDetallesComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    BreadcrumbModule,
    SharedComponentsModule,
    CardModule,
    ReactiveFormsModule,
    MatchHeightModule,
    FormsModule,
    NgbDatepickerModule,
    ArchwizardModule,
    NgSelectModule,
    NgxDropzoneModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    RouterModule.forChild([
      {
        path: 'crearOferta',
        component: DocOfertaWizardComponent
      },
      {
        path: 'oferta/detalles',
        component: DocOfertasDetalleComponent
      },
      {
        path: 'ofertasPublicadas',
        component: DocOfertasActivasComponent
      },
      {
        path: 'enRevision',
        component: DocOfertasRevisionComponent
      },
      {
        path: 'historial',
        component: DocOfertasHistorialComponent
      },
      {
        path: 'oferta/postulados',
        component: DocOfertaPostulantesComponent
      },
      {
        path: 'oferta/postulado',
        component: DocPostulanteDetallesComponent
      }
    ])
  ],
  exports:[RouterModule]
})
export class DocenteModule { }
